"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskBimContextProvider = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var queryStringParser_1 = require("../../components/editableList/queryStringParser");
var App_1 = require("../../App");
var initialMapsInfo = {
    confidential: '',
    description: '',
    tags: [''],
    cause: [''],
    effect: [''],
    notes_decription: '',
    object_title: '',
    type: '',
    object_risk_level_worst_by_color: '',
};
var initialMapsProjectSettings = {
    default_risk_model: 0,
    default_control_model: 0,
    default_coordinate_system: 0,
    project_latitude: 0,
    project_longitude: 0,
    project_z: 0,
    project_latitude_min: 0,
    project_latitude_max: 0,
    project_longitude_min: 0,
    project_longitude_max: 0,
};
var initialRiskBimMapsState = {
    type_id: undefined,
    isOpen: false,
    isReady: false,
    geodata: [],
    project_settings: initialMapsProjectSettings,
    models: [],
    coordinate_systems: [],
    info: initialMapsInfo,
    pickid: '',
    isPicking: false,
    selectedRow: false,
    selectedCoordinate: null,
    isGeoJsonValid: false,
    center: [59.4308, 10.6625],
    locations_count: null,
    all_risks_controls: false,
    updated_marker: null,
    base_layer: ''
};
var RiskBimContext = React.createContext(__assign(__assign({}, initialRiskBimMapsState), { openDialog: undefined, closeDialog: undefined, fetchAll: undefined, onSave: undefined, onAdd: undefined, onDelete: undefined, onUpdateFeature: undefined, onPick: undefined, onMarkerClick: undefined, onChangeCoordinate: undefined, onBaseLayerChange: undefined, onCenterChange: undefined }));
exports.default = RiskBimContext;
var RiskBimContextProvider = (function (_super) {
    __extends(RiskBimContextProvider, _super);
    function RiskBimContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign(__assign({}, initialRiskBimMapsState), { type_id: props.type_id });
        return _this;
    }
    RiskBimContextProvider.prototype.getUrl = function (type_id) {
        if (isNaN(type_id)) {
            return this.props.type === 'risk' ? urls_1.Urls.all_risk_bim_markers : this.props.type === 'control' ? urls_1.Urls.all_control_bim_markers : urls_1.Urls.all_riskcontrol_bim_markers;
        }
        else {
            return this.props.type === 'risk' ? urls_1.Urls.risk_bim_markers : urls_1.Urls.control_bim_markers;
        }
    };
    RiskBimContextProvider.prototype.calculateCentroid = function (geodata) {
        var latitudes = [];
        var longitudes = [];
        var altitudes = [];
        for (var i = 0; i < geodata.length; i++) {
            if (geodata[i].geometry.type === 'Point') {
                latitudes.push(geodata[i].geometry.coordinates[1]);
                longitudes.push(geodata[i].geometry.coordinates[0]);
                altitudes.push(geodata[i].geometry.coordinates[2]);
            }
        }
        var latitude = Math.min.apply(Math, __spreadArray([], __read(latitudes), false)) + (Math.max.apply(Math, __spreadArray([], __read(latitudes), false)) - Math.min.apply(Math, __spreadArray([], __read(latitudes), false))) / 2;
        var longitude = Math.min.apply(Math, __spreadArray([], __read(longitudes), false)) + (Math.max.apply(Math, __spreadArray([], __read(longitudes), false)) - Math.min.apply(Math, __spreadArray([], __read(longitudes), false))) / 2;
        var altitude = Math.min.apply(Math, __spreadArray([], __read(altitudes), false)) + (Math.max.apply(Math, __spreadArray([], __read(altitudes), false)) - Math.min.apply(Math, __spreadArray([], __read(altitudes), false))) / 2;
        return [latitude, longitude, altitude];
    };
    RiskBimContextProvider.prototype.resolveCenter = function (response, center) {
        if (response.geodata.length > 0) {
            return this.calculateCentroid(response.geodata);
        }
        else if (response.center !== undefined && response.center.length > 1) {
            return response.center;
        }
        else if (response.project_settings !== undefined && response.project_settings.project_latitude !== null && response.project_settings.project_longitude !== null) {
            return [response.project_settings.project_latitude, response.project_settings.project_longitude];
        }
        else if (center !== undefined) {
            return center;
        }
        else {
            return [59.4308, 10.6625];
        }
    };
    RiskBimContextProvider.prototype.updateMap = function (response, center) {
        this.setState({
            geodata: response.geodata,
            center: this.resolveCenter(response),
            models: response.models,
            all_risks_controls: true,
            project_settings: response.project_settings
        });
    };
    RiskBimContextProvider.prototype.updateMapForSpecificObjectType = function (response, center) {
        this.setState({
            coordinate_systems: response.coordinate_systems,
            info: response.info,
            isPicking: false,
            models: response.models,
            pickid: '',
            project_settings: response.project_settings,
            selectedRow: false,
            geodata: response.geodata,
            selectedCoordinate: response.project_settings.default_coordinate_system,
            isGeoJsonValid: false,
            center: this.resolveCenter(response, center),
            isReady: true,
            locations_count: response.locations_count,
        });
    };
    RiskBimContextProvider.prototype.fetchAll = function (object_id) {
        var _this = this;
        if (!App_1.store.risklist.has_bim2d && !App_1.store.controllist.has_bim2d) {
            return;
        }
        var type_id = Number(object_id) || this.state.type_id || this.props.type_id;
        var url = this.getUrl(type_id);
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        if (isNaN(type_id)) {
            return jQuery.get((0, urls_1.resolve)(url, this.props.project_id) + "?" + qs.toString(), {}, function (response) {
                if (response.center[0] === null && response.center[1] === null) {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            var center = [position.coords.latitude, position.coords.longitude];
                            _this.updateMap(response, center);
                        }, function (error) {
                            console.log('Unable to retrieve your location.\n' + error.message);
                            _this.updateMap(response);
                        });
                    }
                    else {
                        console.log('Geolocation is not supported by this browser.');
                        _this.updateMap(response);
                    }
                }
                else {
                    _this.updateMap(response);
                }
            });
        }
        else {
            return jQuery.get((0, urls_1.resolve)(url, this.props.project_id, type_id), {}, function (response) {
                if (response.project_settings.project_latitude === null && response.project_settings.project_longitude === null) {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            var center = [position.coords.latitude, position.coords.longitude];
                            _this.updateMapForSpecificObjectType(response, center);
                        }, function (error) {
                            console.log('Unable to retrieve your location.\n' + error.message);
                            _this.updateMapForSpecificObjectType(response);
                        });
                    }
                    else {
                        console.log('Geolocation is not supported by this browser.');
                        _this.updateMapForSpecificObjectType(response);
                    }
                }
                else {
                    _this.updateMapForSpecificObjectType(response);
                }
            });
        }
    };
    RiskBimContextProvider.prototype.closeDialog = function () {
        this.setState({
            type_id: this.props.type_id,
            all_risks_controls: false,
            isOpen: false,
            isReady: false,
            geodata: [],
            locations_count: this.state.geodata.length,
            info: initialMapsInfo,
        });
    };
    RiskBimContextProvider.prototype.openDialog = function (object_id) {
        this.fetchAll(object_id);
        this.setState(function (prev) { return ({
            isOpen: true,
            isReady: true,
            type_id: Number(object_id) || prev.type_id,
            base_layer: 'Risk Level'
        }); });
    };
    RiskBimContextProvider.prototype.onSave = function () {
        var url = this.getUrl(this.state.type_id);
        return jQuery.ajax((0, urls_1.resolve)(url, this.props.project_id, this.state.type_id), {
            type: "POST",
            data: JSON.stringify({
                geodata: this.state.geodata,
            }),
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        })
            .fail(function (response) {
            var data = response.responseJSON;
            data.errors.messages.forEach(function (error_msg) {
                notification(error_msg, { type: "error" });
            });
        })
            .done(function (response) {
            notification(gettext("Map locations were saved successfully"), { type: "success" });
        });
    };
    RiskBimContextProvider.prototype.onAdd = function () {
        var now = new Date();
        var feature = {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [this.state.center[1], this.state.center[0], 0]
            },
            properties: {
                title: "New point",
                object_rotation: 0,
                model_to_use: '',
                object_guid: "new-marker-".concat(now.getTime()),
                object_type: this.state.info.type,
                object_risk_level_worst_by_color: this.state.info.object_risk_level_worst_by_color,
            }
        };
        this.setState(function (prev) {
            return {
                geodata: (prev.geodata || []).concat([feature]),
                isGeoJsonValid: true
            };
        });
    };
    RiskBimContextProvider.prototype.onDelete = function (feature) {
        this.setState(function (prev) {
            var index = prev.geodata.findIndex(function (f) { return f.properties["id"] === feature.properties["id"]; });
            prev.geodata.splice(index, 1);
            return {
                geodata: prev.geodata,
                isGeoJsonValid: true
            };
        });
    };
    RiskBimContextProvider.prototype.onUpdateFeature = function (guid, feature) {
        var geojsondata = this.state.geodata;
        var currentFeature = geojsondata.filter(function (f) { return (f.properties.object_guid === guid); })[0];
        if (typeof feature.geometry !== 'undefined') {
            if (feature.geometry.coordinates[2] === undefined) {
                feature.geometry.coordinates[2] = currentFeature.geometry.coordinates[2];
            }
            currentFeature.geometry.coordinates = feature.geometry.coordinates;
        }
        if (typeof feature.properties !== 'undefined') {
            currentFeature.properties.title = feature.properties.title === undefined ? currentFeature.properties.title : feature.properties.title;
            currentFeature.properties.object_title = feature.properties.object_title === undefined ? currentFeature.properties.object_title : feature.properties.object_title;
            currentFeature.properties.object_rotation = feature.properties.object_rotation === undefined ? currentFeature.properties.object_rotation : feature.properties.object_rotation;
            currentFeature.properties.model_to_use = feature.properties.model_to_use === undefined ? currentFeature.properties.model_to_use : feature.properties.model_to_use;
        }
        var coordinates = currentFeature.geometry.coordinates;
        var geoJsonValid = this.state.isGeoJsonValid;
        var latitude = coordinates[1];
        var longitude = coordinates[0];
        var title = currentFeature.properties.title;
        if (longitude < this.state.project_settings.project_longitude_min || longitude > this.state.project_settings.project_longitude_max || latitude < this.state.project_settings.project_latitude_min || latitude > this.state.project_settings.project_latitude_max || (title === null || title === void 0 ? void 0 : title.length) === 0) {
            geoJsonValid = false;
        }
        else {
            geoJsonValid = true;
        }
        this.setState(function (prevState) {
            return {
                geodata: prevState.geodata,
                pickid: '',
                isPicking: false,
                isGeoJsonValid: geoJsonValid,
                center: [latitude, longitude],
                updated_marker: currentFeature,
            };
        });
    };
    RiskBimContextProvider.prototype.onPick = function (guid) {
        this.setState(function (prevState) {
            return { pickid: guid, isPicking: true };
        });
    };
    RiskBimContextProvider.prototype.onMarkerClick = function (feature) {
        this.setState(function (prevState) {
            return {
                pickid: feature.properties.object_guid,
                selectedRow: true,
                center: [feature.geometry.coordinates[1], feature.geometry.coordinates[0]]
            };
        });
    };
    RiskBimContextProvider.prototype.onChangeCoordinate = function (value) {
        this.setState(function (prevState) {
            return { selectedCoordinate: value };
        });
    };
    RiskBimContextProvider.prototype.onBaseLayerChange = function (name) {
        this.setState(function (prevState) {
            return { base_layer: name };
        });
    };
    RiskBimContextProvider.prototype.onCenterChange = function (center) {
        this.setState({ center: center });
    };
    RiskBimContextProvider.prototype.render = function () {
        return (React.createElement(RiskBimContext.Provider, { value: __assign(__assign({}, this.state), { openDialog: this.openDialog.bind(this), closeDialog: this.closeDialog.bind(this), fetchAll: this.fetchAll.bind(this), onSave: this.onSave.bind(this), onAdd: this.onAdd.bind(this), onDelete: this.onDelete.bind(this), onUpdateFeature: this.onUpdateFeature.bind(this), onPick: this.onPick.bind(this), onMarkerClick: this.onMarkerClick.bind(this), onChangeCoordinate: this.onChangeCoordinate.bind(this), onBaseLayerChange: this.onBaseLayerChange.bind(this), onCenterChange: this.onCenterChange.bind(this) }) }, this.props.children));
    };
    return RiskBimContextProvider;
}(React.Component));
exports.RiskBimContextProvider = RiskBimContextProvider;
